import { Alert, Button, Card, CardActions, CardContent, CardMedia, FormControl, FormLabel, InputLabel, MenuItem, Modal, Select, Snackbar, TextField, Typography } from '@mui/material';
import Header from '../../components/Header';
import HeaderImage from '../../images/header_bg_3.jpg';
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { GiAchievement } from 'react-icons/gi';
import { Verified } from '@mui/icons-material';
import axiosInstance from '../../utils/axiosInstance';

const TraineeProfile = () => {
    const api_link = process.env.REACT_APP_API_URL;
    const { ID, TYPE } = useParams();
    const [subscription, setSubscription] = useState({
        status: '',
        start_date: '',
        end_date: '',
        plan_id: '',
    });
    const [trainee, setTrainee] = useState({
        name: '',
        email: '',
        phone: '',
        durations: '',
        height: '',
        size: 'S',
        weight: '',
        createdAt: '',
        image_url: ''
    })
    const [editTrainee, setEditTrainee] = useState({
        name: '',
        email: '',
        phone: '',
        durations: '',
        height: '',
        size: 'S',
        weight: '',
        createdAt: '',
        image_url: ''
    })
    const [bookings, setBookings] = useState([{
        user_id: '',
        instructor_id: '',
        date: '',
        start_time: '',
        end_time: '',
        duration: '',
        instructor_name: '',
        instructor_email: '',
        instructor_phone: '',
    }])
    const [plans, setPlans] = useState([{
        plan_id: '',
        title: ''
    }])
    const getTraineeRef = useRef()

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedChallenge, setSelectedChallenge] = useState({})
    const [newImageUrl, setNewImageUrl] = useState({});
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState('')
    const [viewOpen, setViewOpen] = useState(false)
    const [viewChallengeOPen, setViewChallengeOpen] = useState(false)
    const [isEditProfileOPen, setIsEditProfileOpen] = useState(false)
    const [challenges, setChallenges] = useState([{
        participation_id: "",
        user_id: "",
        challenge_id: "",
        points_earned: 0,
        penalty_applied: false,
        completed: false,
        createdAt: "",
        challenge_title: "",
        challenge_description: "",
        challenge_category: "",
        challenge_points: 0,
        challenge_duration: "",
        challenge_difficulty: "",
        challenge_image_url: ""
    }])
    const [selectedBooking, setSelectedBooking] = useState({
        user_id: '',
        instructor_id: '',
        date: '',
        start_time: '',
        end_time: '',
        duration: '',
        instructor_name: '',
        instructor_email: '',
        instructor_phone: '',
    });

    const [achievements, setAchievements] = useState([
        {
            achievement_id: '',
            participant_id: '',
            title: '',
            description: '',
            difficulty: '',
            points: '',
            img_url: '',
            createdAt: ''
        }
    ]);

    const handleEditClick = () => {
        setIsEditModalOpen(true);
    };

    const handleModalClose = () => {
        setIsEditModalOpen(false);
    };

    const handleChallengeView = (challenge) => {
        setSelectedChallenge(challenge)
        setViewChallengeOpen(true)
    }

    const handleImageUpdate = async () => {
        setOpen(true);

        if (!newImageUrl || !newImageUrl.name) {
            setMessage("Info! Please select an image and submit or cancel if you don't want to change the image");
            setTimeout(() => setOpen(false), 3000);
            return;
        }

        const formData = new FormData();
        formData.append('image_url', newImageUrl);

        const endpoint = TYPE === 'guest' ? 'guests' : 'members';

        try {
            await axiosInstance.put(`${api_link}${endpoint}/update_profile/${ID}`, formData);
            setMessage(`Success, successfully edited ${auth.name}`);
            setTimeout(() => {
                setOpen(false);
                if (getTraineeRef.current) getTraineeRef.current();
                setIsEditModalOpen(false);
            }, 2000);
        } catch (error) {
            setOpen(false);
            const errorMsg = error.response?.data?.error || error.toString();
            setMessage(`Failure, ${errorMsg}`);
        }
    };

    const auth = localStorage.getItem('gym_user') ? JSON.parse(localStorage.getItem('gym_user')) : null;

    const handleView = (booking) => {
        setViewOpen(true)
        setSelectedBooking(booking);
    }

    const getPlanName = (plan_id) => {
        let plan_name = '';
        plans.forEach(plan => {
            if (plan.plan_id === plan_id) {
                plan_name = plan.title;
            }
        });
        return plan_name;
    }

    const handleEditTrainee = async () => {
        setOpen(true)

        if(!canEdit) {
            setMessage("Info! You are not authorized to edit this trainee's profile")
            setTimeout(() => setOpen(false), 3000);
            return;
        }

        await axiosInstance.put(`${TYPE ==='member'? 'membership' : 'guests'}/update/${ID}`, editTrainee).then(() => {
            setMessage(`Success, successfully edited ${editTrainee.name}`)
            setTimeout(() => {
                if (getTraineeRef.current) getTraineeRef.current();
                setOpen(false)
                setIsEditProfileOpen(false);
            }, 2000)
        }).catch((error) => {
            if(error.status === 400) {
                setMessage('Failure! Try again later')
            } else if(error.status === 404) {
                setMessage('Failure! This trainee does not exist')
            } else if(error.status === 500) {
                setMessage('Failure! System under maintenance! Try again later')
            } else if(error.status === 401) {
                setMessage('Failure! You are not allowed to edit this trainee.')
            }
            setTimeout(() => setOpen(false), 3000)
        })
    }

    const canEdit = auth && (ID === auth.guest_id || ID === auth.member_id);
    useEffect(() => {
        const getUserBoookings = async () => {
            await axiosInstance.get(`bookings/user/${ID}`).then(response => {
                setBookings(response.data.bookings);
            }).catch(() => {
                setBookings([])
            });
        }

        const getTrainee = async () => {
            try {
                const endpoint = TYPE === 'member' ? 'membership' : 'guests';
                const response = await axiosInstance.get(`${endpoint}/${ID}`);
                const data = TYPE === 'member' ? response.data.data : response.data.guest;
                setTrainee(data);
                setEditTrainee(data);
            } catch {
                setTrainee({});
                setEditTrainee(TYPE === 'guest' ? {} : undefined);
            }
        };

        const getChallenges = async () => {
            await axiosInstance.get(`paticipations/user/${ID}`).then(response => {
                setChallenges(response.data.data);
            }).catch(() => {
                setChallenges([])
            });
        }

        const getAchievements = async () => {
            await axiosInstance.get(`achievements/participant/${ID}`).then((response) => {
                setAchievements(response.data.achievements);
            }).catch(() => {
                setAchievements([]);
            })
        }
        
        const getSubscriptionDetailsForUser = () => {
            axiosInstance.get(`membershipsubscription/subscription/${ID}`).then(response => {
                setSubscription(response.data.data);
            }).catch(() => {
                setSubscription({})
           })
        }

        const getPlans = async () => {
            await axiosInstance.get(`plans/all`).then((response) => {
                setPlans(response.data.data);
            }).catch((error) => {
                setPlans([]);
            });
        }

        getTraineeRef.current = getTrainee;

        getTrainee();
        getChallenges();
        getUserBoookings();
        getPlans()
        getAchievements();
        getSubscriptionDetailsForUser()
    }, [api_link, ID, TYPE])

    return (
        <div>
            <Header title="Trainee Profile" image={HeaderImage}>
                Welcome to your fitness journey! Track your progress, review your achievements, and stay motivated to reach your goals.
            </Header>

            <div className="columns-1 lg:flex gap-8 p-10 lg:px-20 items-start">
                {/* Profile Image Section */}
                <div className="flex flex-col justify-center items-center w-full lg:w-[30%] mb-4 space-y-4">
                    <div className="relative">
                        <img src={trainee.image_url ? trainee.image_url : "https://true-elevate.com/wp-content/uploads/2024/04/360_F_317917629_HjBCyRlH1Hpwwg2HfEbExTdkbyWiGFuN.jpg"} alt={trainee.name} className="rounded-full w-72 h-72 md:w-96 md:h-96 shadow-lg" />
                        {canEdit && (
                            <button onClick={handleEditClick} className="absolute bottom-10 right-10 bg-blue-600 text-white rounded-full p-2 shadow-md hover:bg-blue-700 w-8 h-8 flex items-center justify-center">
                                🖉
                            </button>
                        )}
                    </div>
                    <div className='flex gap-1'>
                        <h2 className="text-2xl font-bold text-white">{trainee.name}</h2>
                        {subscription && subscription.status === 'active' ? <Verified color="success" className="text-sm" /> : ''}
                    </div>

                    {/* Personalized Note */}
                    <Card className="p-6 shadow-lg w-full">
                        <div className='flex justify-between'>
                            <h2 className="text-lg font-bold text-[#c7b262] mb-4">Profile info</h2>

                            {canEdit &&
                                <button className="text-blue-600 p-2 shadow-md font-extrabold" onClick={() => setIsEditProfileOpen(true)}>
                                    🖉
                                </button>
                            }
                        </div>
                        <p className="text-gray-700">
                            <span className='w-48'>Phone: </span><b>{trainee.phone || 'Private'}</b><br />
                            <span className='w-48'>Email: </span><b>{trainee.email || 'Private'}</b><br />
                            {TYPE === 'member' && <>
                                <span className='w-48'>Duration: </span><b>{trainee.durations ? `${trainee.durations} Weeks` : 'Private'}</b><br />
                                <span className='w-48'>Height: </span><b>{trainee.height ? `${trainee.height} ft` : 'Private'}</b><br />
                                <span className='w-48'>Size: </span><b>{trainee.size || 'Private'}</b><br />
                                <span className='w-48'>Weight: </span><b>{trainee.weight ? `${trainee.weight} kg` : 'Private'}</b><br />
                            </>}
                        </p>

                        {canEdit ?
                            <>
                                <br />
                                <h2 className="text-lg font-bold text-[#c7b262] mb-2">Subscription info</h2>
                                <p className="text-gray-700">
                                    <span className='w-48'>Plan: </span><b>{getPlanName(subscription.plan_id) || 'private'}</b><br />
                                    <span className='w-48'>Status: </span><b>{subscription.status}</b><br />
                                    <span className='w-48'>Start Date: </span><b>{subscription.start_date || 'private'}</b><br />
                                    <span className='w-48'>End Date: </span><b>{subscription.end_date || 'private'}</b>
                                </p>
                            </>
                        :
                            <></>
                        }
                    </Card>
                </div>

                {/* Profile Details Section */}
                <div className="flex flex-col w-full lg:w-[70%] gap-6">
                    {/* Schedule */}
                    <Card className="p-6 shadow-lg w-full">
                        <h2 className="text-lg font-bold text-gray-800 mb-4">My Workout Schedule</h2>
                        <ul className="grid grid-cols-1 md:grid-cols-2">
                            {bookings.length > 0 ?
                                bookings.map((booking, index) =>
                                    <li key={index} className="flex justify-between items-center bg-gray-200 p-4 rounded-md shadow-sm cursor-pointer" onClick={() => handleView(booking)}>
                                        <span className="text-gray-700 font-medium">{booking.date.slice(0, 10)} ⮚ {booking.instructor_name}</span>
                                        <span className="text-gray-500 text-sm">{booking.start_time.slice(0, 6)} AM - {booking.end_time.slice(0, 5)} AM</span>
                                    </li>
                                )
                                :
                                <div className='border border-red-700 text-red-700 text-center font-bold'>No booking yet</div>
                            }
                        </ul>
                    </Card>

                    {/* Achievements */}
                    <div className="p-6 px-0 w-full">
                        <h2 className="text-lg font-bold text-white mb-4">My Achievements</h2>
                        {achievements.length > 0 ? (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                {achievements.map((achievement) =>
                                    <div key={achievement.achievement_id} className="flex flex-col items-center bg-gray-50 p-4 rounded-md shadow-sm text-center">
                                        <GiAchievement size={50} color="green" className='mb-10' />
                                        <h3 className="text-gray-800 font-semibold mb-2">{achievement.title}</h3>
                                        <p className="text-gray-600 text-sm">{achievement.description}</p>
                                    </div>
                                )}
                            </div>)
                        :
                            <div className='border border-red-700 text-red-700 text-center font-bold'>No achievements yet.</div>
                        }
                    </div>

                    {/* Challenges */}
                    <div className="p-6 px-0 w-full">
                        <h2 className="text-lg font-bold text-white mb-4">Challenges</h2>
                        {challenges.length > 0 ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                                {challenges.map((challenge, index) =>
                                    <Card className="shadow-lg" key={index}>
                                        <CardMedia sx={{ height: 120 }} image={challenge.challenge_image_url || 'https://via.placeholder.com/600x300'} title={challenge.title} />
                                        <CardContent>
                                            <Typography variant="h4" className="text-green-600 font-bold mb-2">
                                                {challenge.challenge_title}
                                            </Typography>
                                            <Typography variant="body1" className="mb-4">
                                                {challenge.challenge_description}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small" variant="outlined" className='py-2' onClick={() => handleChallengeView(challenge)}><FaEye /></Button>
                                        </CardActions>
                                    </Card>
                                )}
                            </div>)
                        :
                            <div className='border border-red-700 text-red-700 text-center font-bold'>Not in any challenge.</div>
                        }
                    </div>
                </div>
            </div>

            {/* Edit Image Modal */}
            <Modal open={isEditModalOpen} onClose={handleModalClose} className='flex justify-center items-center'>
                <div className="bg-white w-[90%] lg:w-[40%] p-8 rounded-md shadow-md mx-auto mt-20">
                    <h2 className="text-blue-950 mb-4">Edit Profile Image</h2>
                    <FormLabel>Image</FormLabel>
                    <TextField fullWidth type='file' variant="outlined" onChange={(e) => setNewImageUrl(e.target.files[0])} className="mb-4" />
                    <div className="flex justify-end gap-4 mt-8">
                        <Button onClick={handleModalClose} variant="outlined" color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={handleImageUpdate} variant="contained" color="primary">
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* View booking Modal */}
            <Modal open={viewOpen} onClose={() => setViewOpen(false)} className='flex justify-center items-center'>
                <div className="bg-white w-[90%] lg:w-[40%] p-8 rounded-md shadow-md mx-auto mt-20 text-blue-950">
                    <h2 className="mb-4 text-blue-950">Your booking</h2>
                    <ul>
                        <li>
                            <strong>Date:</strong> {selectedBooking.date.slice(0, 10)}
                        </li>
                        <li>
                            <strong>Start Time:</strong> {selectedBooking.start_time.slice(0, 6)} AM
                        </li>
                        <li>
                            <strong>End Time:</strong> {selectedBooking.end_time.slice(0, 5)} AM
                        </li>
                        <li>
                            <strong>Instructor:</strong> {selectedBooking.instructor_name}
                        </li>
                        <li>
                            <strong>Email:</strong> {selectedBooking.instructor_email}
                        </li>
                        <li>
                            <strong>Phone:</strong> {selectedBooking.instructor_phone}
                        </li>
                    </ul>

                    <div className="flex justify-end gap-4 mt-8">
                        <Button onClick={() => setViewOpen(false)} variant="outlined" color="secondary">
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal open={viewChallengeOPen} onClose={() => setViewChallengeOpen(false)} className="flex justify-center items-center">
                <div className="bg-white w-[90%] lg:w-[50%] p-8 rounded-md shadow-md mx-auto mt-20 text-gray-900">
                    <h2 className="text-xl font-bold text-blue-800 mb-4">Challenge <b>{selectedChallenge.challenge_title}</b></h2>
                    <img src={selectedChallenge.challenge_image_url} alt={selectedChallenge.challenge_title} className="w-full h-64 object-cover rounded-md mb-6" />
                    <p className="text-sm text-gray-700 mb-4">
                        <strong>Description:</strong> {selectedChallenge.challenge_description}
                    </p>
                    <ul className="space-y-2">
                        <li>
                            <strong>Category:</strong> {selectedChallenge.challenge_category}
                        </li>
                        <li>
                            <strong>Difficulty:</strong> {selectedChallenge.challenge_difficulty}
                        </li>
                        <li>
                            <strong>Points:</strong> {selectedChallenge.challenge_points}
                        </li>
                        <li>
                            <strong>Duration:</strong> {selectedChallenge.challenge_duration}
                        </li>
                        <li>
                            <strong>Points Earned:</strong> {selectedChallenge.points_earned}
                        </li>
                        <li>
                            <strong>Penalty Applied:</strong> {selectedChallenge.penalty_applied ? "Yes" : "No"}
                        </li>
                        <li>
                            <strong>Completed:</strong> {selectedChallenge.completed ? "Yes" : "No"}
                        </li>
                    </ul>

                    <div className="flex justify-end gap-4 mt-8">
                        <Button onClick={() => setViewChallengeOpen(false)} variant="outlined" color="secondary">
                            Close
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* edit user */}
            <Modal open={isEditProfileOPen} onClose={() => setIsEditProfileOpen(false)} className="flex justify-center items-center">
                <div className="bg-white w-[90%] lg:w-[50%] p-8 rounded-md shadow-md mx-auto mt-20 text-gray-900">
                    <h2 className="text-blue-950 mb-4">Edit Profile</h2>
                    <TextField fullWidth type='text' variant="outlined" label="Edit name" className="mb-4" style={{ marginBottom: 15 }} value={editTrainee.name} onChange={(e) => setEditTrainee((prev) => ({...prev, name: e.target.value}))} />
                    <TextField fullWidth type='email' variant="outlined" label="Edit email" className="mb-4" style={{ marginBottom: 15 }} value={editTrainee.email} onChange={(e) => setEditTrainee((prev) => ({...prev, email: e.target.value}))} />
                    <TextField fullWidth type='tel' variant="outlined" label="Edit phone" className="mb-4" style={{ marginBottom: TYPE === 'member' ? 15 : 0 }} value={editTrainee.phone} onChange={(e) => setEditTrainee((prev) => ({...prev, phone: e.target.value}))} />
                    {TYPE === 'member' && <>
                        <TextField fullWidth type='number' variant="outlined" label="Edit duration" className="mb-4" style={{ marginBottom: 15 }} value={editTrainee.durations} onChange={(e) => setEditTrainee((prev) => ({...prev, durations: e.target.value}))} />
                        <TextField fullWidth type='number' variant="outlined" label="Edit height" className="mb-4" style={{ marginBottom: 15 }} value={editTrainee.height} onChange={(e) => setEditTrainee((prev) => ({...prev, height: e.target.value}))} />
                        <FormControl fullWidth style={{ marginBottom: 15 }}>
                            <InputLabel>Size</InputLabel>
                            <Select label="Select Size" value={editTrainee.size} onChange={(e) => setEditTrainee((prev) => ({...prev, size: e.target.value}))}>
                                <MenuItem value="S">
                                    Small
                                </MenuItem>
                                <MenuItem value="M">
                                    Medium
                                </MenuItem>
                                <MenuItem value="L">
                                    Large
                                </MenuItem>
                                <MenuItem value="XL">
                                    Extra Large
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField fullWidth type='number' variant="outlined" label="Edit weight" className="mb-4" value={editTrainee.weight} onChange={(e) => setEditTrainee((prev) => ({...prev, weight: e.target.value}))} />
                    </>}
                    <div className="flex justify-end gap-4 mt-8">
                        <Button variant="outlined" color="error" onClick={() => setIsEditProfileOpen(false)}>Close</Button>
                        <Button variant="outlined" color="primary" onClick={handleEditTrainee}>Update</Button>
                    </div>
                </div>
            </Modal>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    );
};

export default TraineeProfile;
